"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.TitleBarIcon = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _Icon = require("@fluentui/react/lib/Icon");

var React = _interopRequireWildcard(require("react"));

var getClassNames = (0, _react.classNamesFunction)();

var TitleBarIconBase = function TitleBarIconBase(_ref) {
  var className = _ref.className,
      iconName = _ref.iconName,
      iconProps = _ref.iconProps,
      styles = _ref.styles;
  var classes = getClassNames(styles);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _react.css)('ms-TitleBar--iconContainer', className, classes.root),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, (0, _objectSpread2.default)({
      className: 'ms-TitleBar--icon',
      iconName: iconName
    }, iconProps))
  });
};

var TitleBarIcon = (0, _react.styled)(TitleBarIconBase, {
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: '0 0 48px',
    fontSize: '1.3rem'
  }
});
exports.TitleBarIcon = TitleBarIcon;